/**
 * Logger Utility
 * Centralized logging with environment-aware output
 * 
 * In production, only errors are logged.
 * In development, all levels are logged with clear formatting.
 * 
 * Updated to match mobile app logger structure.
 */

const IS_DEV = process.env.NODE_ENV === 'development';

class Logger {
  /**
   * Log error (always logged, even in production)
   */
  error(module, message, data = {}) {
    console.error(`[${module}] ❌ ${message}`, data);
    // STUB: Send to error tracking service (Sentry, LogRocket, etc.)
    // if (!IS_DEV && window.Sentry) {
    //   window.Sentry.captureException(new Error(message), { extra: { module, data } });
    // }
  }

  /**
   * Log warning (dev only)
   */
  warn(module, message, data = {}) {
    if (IS_DEV) {
      console.warn(`[${module}] ⚠️ ${message}`, data);
    }
  }

  /**
   * Log info (dev only)
   */
  info(module, message, data = {}) {
    if (IS_DEV) {
      console.log(`[${module}] ℹ️ ${message}`, data);
    }
  }

  /**
   * Log debug (dev only)
   */
  debug(module, message, data = {}) {
    if (IS_DEV) {
      console.log(`[${module}] 🐛 ${message}`, data);
    }
  }

  /**
   * Log success (dev only)
   */
  success(module, message, data = {}) {
    if (IS_DEV) {
      console.log(`[${module}] ✅ ${message}`, data);
    }
  }
}

export default new Logger();

